import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  Checkbox,
  FormControlLabel,
  Paper,
  Divider,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const PaymentModal = ({ open, onClose, openBankModal }) => {
  const [selected, setSelected] = useState("");

  const handleSelect = (method) => {
    setSelected(method === selected ? "" : method);
  };

  const handleProceed = () => {
    openBankModal();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 3,
          maxWidth: 400,
          mx: "auto",
          mt: "10vh",
          backgroundColor: "#fff",
          borderRadius: 4,
          boxShadow: 24,
          outline: "none",
        }}
      >
        {/* Icon */}
        <Box textAlign="center" mb={2}>
          <Box
            sx={{
              backgroundColor: "#d1fadf",
              width: 60,
              height: 60,
              mx: "auto",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CreditCardIcon sx={{ color: "#4caf50", fontSize: 32 }} />
          </Box>
        </Box>

        {/* Title and Description */}
        <Typography variant="h6" fontWeight="bold" textAlign="center">
          How would you like to pay?
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mb={2}>
          Your payment is required to complete the booking but it will be kept until the Doctor has delivered service.
        </Typography>

        {/* Payment Options */}
        <Box>
          <Paper
            variant="outlined"
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: selected === "wallet" ? "#e7fbe7" : "#f6f6f6",
              border: selected === "wallet" ? "2px solid #4caf50" : "1px solid #ccc",
              borderRadius: 2,
              cursor: "pointer",
            }}
            onClick={() => handleSelect("wallet")}
          >
            <FormControlLabel
              control={<Checkbox checked={selected === "wallet"} />}
              label="Pay from your ConnectingHealth Wallet"
            />
          </Paper>

          <Paper
            variant="outlined"
            sx={{
              p: 1,
              backgroundColor: selected === "other" ? "#e7fbe7" : "#f6f6f6",
              border: selected === "other" ? "2px solid #4caf50" : "1px solid #ccc",
              borderRadius: 2,
              cursor: "pointer",
            }}
            onClick={() => handleSelect("other")}
          >
            <FormControlLabel
              control={<Checkbox checked={selected === "other"} />}
              label="Pay with other options"
            />
          </Paper>
        </Box>

        {/* Proceed Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, backgroundColor: "#00b050", "&:hover": { backgroundColor: "#009944" } }}
          onClick={handleProceed}
          disabled={!selected}
        >
          Proceed with Payment
        </Button>

        {/* Cancel Appointment */}
        <Button
          fullWidth
          variant="text"
          color="inherit"
          sx={{ mt: 1 }}
          onClick={onClose}
        >
          Cancel Appointment
        </Button>
      </Box>
    </Modal>
  );
};

export default PaymentModal;
